import React, { useState } from 'react';
import { Button, Grid2 as Grid, Typography, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox, Box, TextField, InputAdornment } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { Route, Order } from 'typings/models';


interface OrderSelectionProps {
    orders: Order[];
    selectedOrderIds: string[];
    setSelectedOrderIds: (orderIds: string[]) => void;
}

const OrderSelection: React.FC<OrderSelectionProps> = ({ orders, selectedOrderIds, setSelectedOrderIds }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredOrders = searchTerm.trim() === ''
        ? orders
        : orders.filter(order =>
            order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
            order.client.name.toLowerCase().includes(searchTerm.toLowerCase())
          );

    const groupedOrders = filteredOrders.reduce((acc: { [key: string]: Order[] }, order) => {
        const date = new Date(order.created_at).toISOString().split('T')[0];
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(order);
        return acc;
    }, {});
    const sortedGroupedOrders = Object.keys(groupedOrders).sort((a, b) => new Date(b).getTime() - new Date(a).getTime());

    return (
        <>
            <Grid size={{xs: 12, sm: 12}}>
                <Typography variant="h6">Seleccion de órdenes</Typography>
            </Grid>

            <Grid size={{xs: 12, sm: 12}}>
                <Typography variant="body2" color="textSecondary">
                    Las órdenes están agrupadas por día. Haz click en la fecha para expandir y seleccionar las órdenes.
                </Typography>
            </Grid>

            <Grid size={{xs: 12, sm: 12}} sx={{ mb: 2, mt: 1 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Buscar por Número de Factura o nombre del cliente"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>

            <div style={{ marginBottom: 20 }}>
                {sortedGroupedOrders.length > 0 ? (
                    sortedGroupedOrders.map(date => {
                        const orderedOrders = groupedOrders[date].sort((a, b) => a.client.name.localeCompare(b.client.name));
                        return (
                            <Accordion
                                key={date}
                                sx={{backgroundColor: '#E0E0E0'}}
                                defaultExpanded={searchTerm.trim() !== ''}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">{date}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{backgroundColor: '#EEEEEE'}}>
                                    <FormControlLabel
                                        sx={{marginBottom: 2}}
                                        control={
                                            <Checkbox
                                                id={`select-all-${date}`}
                                                color="success"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        const allOrderIds = groupedOrders[date].map(order => order.id);
                                                        setSelectedOrderIds(Array.from(new Set([...selectedOrderIds, ...allOrderIds])));
                                                    } else {
                                                        const allOrderIds = groupedOrders[date].map(order => order.id);
                                                        setSelectedOrderIds(selectedOrderIds.filter(id => !allOrderIds.includes(id)));
                                                    }
                                                }}
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                            />
                                        }
                                        label={<span style={{ color: 'blue' }}>Seleccionar todos</span>}
                                    />

                                    <Box sx={{ maxHeight: 200, overflowY: 'auto', backgroundColor: 'white', padding: 1 }}>
                                        {orderedOrders.map(order => (
                                            <>
                                            <FormControlLabel
                                                key={order.id}
                                                control={
                                                    <Checkbox
                                                        id={`order-${order.id}`}
                                                        value={order.id}
                                                        checked={selectedOrderIds.includes(order.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedOrderIds([...selectedOrderIds, order.id]);
                                                            } else {
                                                                setSelectedOrderIds(selectedOrderIds.filter(id => id !== order.id));
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={<span>{order.id} - {order.client.name}</span>}
                                            />
                                            <br/>
                                            </>
                                        ))}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                ) : (
                    <Typography variant="body1" sx={{ textAlign: 'center', mt: 2 }}>
                        No se encontraron órdenes que coincidan con la búsqueda
                    </Typography>
                )}
            </div>
        </>
    );
};

export default OrderSelection;
